export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["搜索"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["单击以选择要显示的列"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["显示的列"])}
}